import React, { useState } from 'react';

function EliminarCuenta() {
  const [email, setEmail] = useState('');
  const [motivo, setMotivo] = useState('');
  const [enviado, setEnviado] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    // Simula el envío (2s) — aquí se puede conectar a un endpoint real
    await new Promise((res) => setTimeout(res, 1500));
    setEnviado(true);
    setLoading(false);
  };

  const s = {
    page: { maxWidth: '600px', margin: '0 auto', padding: '48px 24px', fontFamily: 'system-ui, sans-serif', color: '#1e293b', lineHeight: '1.7' },
    title: { fontSize: '26px', fontWeight: '800', marginBottom: '8px' },
    subtitle: { color: '#64748b', marginBottom: '32px', fontSize: '15px' },
    label: { display: 'block', fontWeight: '600', fontSize: '14px', marginBottom: '6px' },
    input: { width: '100%', padding: '10px 14px', border: '1px solid #cbd5e1', borderRadius: '10px', fontSize: '15px', marginBottom: '16px', boxSizing: 'border-box' },
    textarea: { width: '100%', padding: '10px 14px', border: '1px solid #cbd5e1', borderRadius: '10px', fontSize: '15px', marginBottom: '20px', boxSizing: 'border-box', resize: 'vertical', minHeight: '100px' },
    btn: { background: '#dc2626', color: '#fff', border: 'none', borderRadius: '10px', padding: '12px 28px', fontSize: '15px', fontWeight: '700', cursor: 'pointer', width: '100%' },
    info: { background: '#fef3c7', border: '1px solid #fcd34d', borderRadius: '10px', padding: '14px 16px', fontSize: '14px', color: '#92400e', marginBottom: '24px' },
    success: { background: '#f0fdf4', border: '1px solid #86efac', borderRadius: '12px', padding: '32px', textAlign: 'center' },
  };

  return (
    <div style={s.page}>
      <h1 style={s.title}>Eliminar cuenta y datos</h1>
      <p style={s.subtitle}>
        Puedes solicitar la eliminación de tu cuenta y todos los datos asociados. Procesaremos tu solicitud en un plazo máximo de <strong>30 días</strong>.
      </p>

      {!enviado ? (
        <>
          <div style={s.info}>
            ⚠️ <strong>Importante:</strong> La eliminación es permanente. Se borrarán tu cuenta, incidencias, comentarios y cualquier dato asociado. Esta acción no se puede deshacer.
          </div>

          <form onSubmit={handleSubmit}>
            <label style={s.label}>Correo electrónico de tu cuenta *</label>
            <input
              style={s.input}
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@email.com"
            />

            <label style={s.label}>Motivo (opcional)</label>
            <textarea
              style={s.textarea}
              value={motivo}
              onChange={(e) => setMotivo(e.target.value)}
              placeholder="Cuéntanos por qué quieres eliminar tu cuenta..."
            />

            <button style={s.btn} type="submit" disabled={loading}>
              {loading ? 'Enviando solicitud...' : 'Solicitar eliminación de cuenta'}
            </button>
          </form>
        </>
      ) : (
        <div style={s.success}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>✅</div>
          <h2 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '8px' }}>Solicitud recibida</h2>
          <p style={{ color: '#166534', marginBottom: '0' }}>
            Hemos recibido tu solicitud para eliminar la cuenta <strong>{email}</strong>.<br />
            La procesaremos en un máximo de 30 días y recibirás una confirmación.
          </p>
        </div>
      )}

      <hr style={{ margin: '40px 0', border: 'none', borderTop: '1px solid #e2e8f0' }} />
      <p style={{ color: '#94a3b8', fontSize: '13px' }}>
        © 2026 HabitaPro. ·{' '}
        <a href="/privacidad" style={{ color: '#94a3b8' }}>Política de privacidad</a>
      </p>
    </div>
  );
}

export default EliminarCuenta;
